import { gql } from "@apollo/client";
import moment from "moment";

const TIPO_DNI = 1;

export const GET_PACIENTES_PAGINATED_RECLAMOS = gql`
query GetAllPacientes(
    $skip: Int
    $take: Int
    $where: t_PacienteFilterInput  
    $order: [t_PacienteSortInput!]
) {
    allPatientsWithApprovedEvaluations(skip: $skip, take: $take, order: $order, where: $where)
    {
        items {
            idPaciente
            nombre
            apellido
            idTipoDocumento
            numeroDocumento
            sexo
            fechaNacimiento
        }
        totalCount
    }
}`;

export const adaptPaciente = (paciente) => {
  return {
    idPaciente: paciente.idPaciente,
    nombre: paciente.nombre,
    apellido: paciente.apellido,
    idTipoDocumento: paciente.idTipoDocumento === TIPO_DNI ? 'DNI' : 'Pasaporte',
    numeroDocumento: paciente.numeroDocumento,
    sexo: paciente.sexo,
    fechaNacimiento: moment(paciente.fechaNacimiento).format("YYYY-MM-DD")
  };
};

export const adaptPacientesArray = (pacientes) => {
  return structuredClone(pacientes)?.
  map((paciente) => adaptPaciente(paciente));
};